import { numberToDollars } from '../../../../utils'

const dollars = amount => `$${numberToDollars(amount, true)}`
const percent = value => `${numberToDollars(value, true)}%`

// Compare rounded amounts so the heading matches the values shown.
function getSavingChange(currentMonthly, recommendedMonthly) {
  const current = Math.round(currentMonthly)
  const recommended = Math.round(recommendedMonthly)
  if (recommended === current) return 'keep'
  if (current === 0) return 'start'
  return recommended > current ? 'increase' : 'decrease'
}

const LEAD_WITH_SPOUSE = {
  keep: 'Keep your household saving at ',
  increase: 'Increase your household saving to ',
  decrease: 'Decrease your household saving to ',
  start: 'Start saving ',
}

const LEAD_WITHOUT_SPOUSE = {
  keep: 'Keep saving ',
  increase: 'Increase your saving to ',
  decrease: 'Decrease your saving to ',
  start: 'Start saving ',
}

const lowercaseFirst = text => text.charAt(0).toLowerCase() + text.slice(1)

export function getHeadingSegments({
  includeSpouse,
  isModified,
  currentMonthly,
  recommendedMonthly,
  isPercentOnly,
  aggregatePercent,
}) {
  const change = getSavingChange(currentMonthly, recommendedMonthly)

  let lead = (includeSpouse ? LEAD_WITH_SPOUSE : LEAD_WITHOUT_SPOUSE)[change]
  if (isModified) {
    lead = `You've chosen to ${lowercaseFirst(lead)}`
  }

  // Do not show the percentage for household saving.
  const showPercent = !includeSpouse && isPercentOnly
  const amount = showPercent
    ? `${dollars(recommendedMonthly)} (${percent(aggregatePercent)})`
    : dollars(recommendedMonthly)

  const trail =
    change === 'start' && includeSpouse ? ' every month as a household.' : ' every month.'

  return {
    segments: [{ text: lead }, { text: amount, bold: true }, { text: trail }],
  }
}
